import { render, staticRenderFns } from "./ClearPin.vue?vue&type=template&id=ecd8a774&scoped=true&lang=pug&"
import script from "./ClearPin.vue?vue&type=script&lang=js&"
export * from "./ClearPin.vue?vue&type=script&lang=js&"
import style0 from "./ClearPin.vue?vue&type=style&index=0&id=ecd8a774&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd8a774",
  null
  
)

export default component.exports